import anime from 'animejs';

const measureHeight = (el: HTMLElement) => {
	const cachedStyles = el.getAttribute('style');
	el.setAttribute('style', '');
	const height = el.offsetHeight;
	const { marginTop, marginBottom, paddingTop, paddingBottom } =
		window.getComputedStyle(el);

	if (cachedStyles) {
		el.setAttribute('style', cachedStyles);
	}

	return { height, marginTop, marginBottom, paddingTop, paddingBottom };
};

const utilMakeHeightSetting = (opts: any) => ({
	delay: 0,
	...opts,
});

/**
 * Show and hide by sliding up and down
 */

const slideHeightDuration = 350;
const slideOpacityDuration = 100;

export function slideShow(el: HTMLElement, callback = () => {}) {
	const { height, marginTop, marginBottom, paddingTop, paddingBottom } =
		measureHeight(el);
	el.style.display = 'block';

	const animationSettings = {
		duration: slideHeightDuration,
		easing: 'cubicBezier(.05,1,.2,1)',
	};

	anime({
		targets: el,
		easing: 'easeInOut',
		height: utilMakeHeightSetting({
			value: [0, height],
			...animationSettings,
		}),
		marginTop: utilMakeHeightSetting({
			value: [0, marginTop],
			...animationSettings,
		}),
		marginBottom: utilMakeHeightSetting({
			value: [0, marginBottom],
			...animationSettings,
		}),
		paddingTop: utilMakeHeightSetting({
			value: [0, paddingTop],
			...animationSettings,
		}),
		paddingBottom: utilMakeHeightSetting({
			value: [0, paddingBottom],
			...animationSettings,
		}),
		opacity: {
			value: [0, 1],
			delay: slideHeightDuration - slideOpacityDuration,
			duration: slideOpacityDuration,
			easing: 'linear',
		},
		complete: () => {
			el.removeAttribute('style');
			callback();
		},
	});
}

export function slideHide(el: HTMLElement, callback = () => {}) {
	const heightSetting = utilMakeHeightSetting({
		value: 0,
		duration: slideHeightDuration,
		easing: 'cubicBezier(.85,.07,.38,1)',
	});

	anime({
		targets: el,
		height: heightSetting,
		marginTop: heightSetting,
		marginBottom: heightSetting,
		paddingTop: heightSetting,
		paddingBottom: heightSetting,
		opacity: {
			value: 0,
			delay: 0,
			duration: slideOpacityDuration,
			easing: 'linear',
		},
		complete: () => {
			el.style.display = 'none';
			callback();
		},
	});
}
